import React from 'react'
import Search from './Search'
import SetupPage from 'modules/setup/SetupPage'
import EmbalajeInfoTab from './embalajeInfo/EmbalajeInfoTab'
import { faSquare } from '@fortawesome/free-solid-svg-icons'

const EmbalajeSetup = () => {

	const setupProps = {
		title: "Embalajes",
		icon: faSquare,
		addNewTitle: "Crear embalaje",
		searchUrl: "/embalajeSetup/search",
		rowKey: "idEmbalaje",
		columns: [
			{ key: "idEmbalaje", name: "ID", sortable: true, width: 60 },
			{ key: "nombre", name: "Nombre", sortable: true },
		],
		tabs: [
			{ key: "info", title: "Info", comp: EmbalajeInfoTab }
		]
	};

	return (
		<SetupPage
			setupProps={setupProps}
			search={Search} />
	)
}

export default EmbalajeSetup;